















































import { Vue, Component, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { Carousel, CarouselItem } from 'element-ui';
import { get } from 'lodash';

import { DEFAULT_AVATAR } from '@/config/map.conf';
import TopNav from './topNavbar.vue';

import * as api from '@/api';
import store from '@/store';

/**
 * 页面布局
 *
 * @author xiaokunyu
 * @date 01/11/2019
 */
@Component({
    components: {
        Carousel,
        CarouselItem,
        TopNav
    }
})
export default class Layout extends Vue {
    @State(state => state.cti.env)
    env: string;
    activeName: string = 'cti';
    mis: string = '';
    name: string = '';
    instructionVer: string = '';
    instruction: any = [];
    visible: Boolean = false;
    shouldShowInstruction: Boolean = false;
    activeInstructionIndex: number = 0;

    hasSpacePermission: boolean = false;

    userAvatar: string = 'DEFAULT_AVATAR';

    $refs: { instructionCarousel: Carousel };

    handleSelect() {
        this.$router.push({ name: this.activeName }).catch(e => e);
    }
    // TODO: MTD支持onClose后 使用onclose回调替换watch.
    // 用户手动关闭模态框之后，记录行为，不再展示同一个模态框。
    @Watch('shouldShowInstruction')
    onInstructionModalDisappear(newShould) {
        if (newShould === false) {
            localStorage.setItem('lastInstructionVer', this.instructionVer);
        }
    }
    mounted() {
        this.getUserInfo();
        this.getSpacePermission();
        // 用户引导
        this.getUserInstruction();
        this.activeTabOnRefresh();
    }
    activeTabOnRefresh() {
        const mainRouteName = this.$route.name.split('_')[0];
        this.activeName = mainRouteName || 'cti';
    }
    onCarouselChange(newIndex) {
        this.activeInstructionIndex = newIndex;
    }
    handleModalBtn() {
        if (this.isCarouselNotOnLastPage) {
            this.activeInstructionIndex++;
            this.$refs.instructionCarousel.setActiveItem(this.activeInstructionIndex);
        } else {
            this.shouldShowInstruction = false;
        }
    }
    async getUserInfo() {
        try {
            const res = await api.ctiApi.getUserInfo();
            this.name = res.data.displayname;
            this.mis = res.data.username;
            store.commit('GET_USER_INFO', res.data);
            this.getUserAvatar();
        } catch (e) {
            console.log(e);
        }
    }
    async getSpacePermission() {
        try {
            const res = await api.spaceApi.getSpacePermission();
            const { code, data } = res;
            if (code === 200) this.hasSpacePermission = data.hasSpacePermission;
        } catch (e) {
            console.log(e);
        }
    }
    async getUserInstruction() {
        try {
            const res = await api.ctiApi.getUserInstruction();
            // 从localstorage取出之前看过的version: str
            const prevVer = localStorage.getItem('lastInstructionVer');
            // const { version: versionInt, items: instruction } = res.data || {};
            // const { version, items: instruction } = mockInstructions;
            // 小心的取出接口返回的version: int
            const versionInt = get(res, 'data.version');
            // 小心的取出接口返回的instruction: array
            const instruction = get(res, 'data.items', []);
            // 接口有version的话，把int转成str，否则version undefined
            const version = versionInt ? versionInt.toString() : undefined;
            // 如果有version，而且跟之前看过的不一致，把version和instruction放到store里面，打开modal
            if (version && prevVer !== version) {
                this.instruction = instruction;
                this.instructionVer = version;
                this.shouldShowInstruction = true;
            }
        } catch (e) {
            console.log(e);
        }
    }
    // 获取头像
    async getUserAvatar() {
        const res = await api.ctiApi.searchDisplayNameList([this.mis]);
        const { code, data } = res;
        if (code === 200) {
            this.userAvatar = (data[this.mis] && data[this.mis].avatar) || DEFAULT_AVATAR;
        }
    }
    get ticketUrl() {
        return this.env === 'prod' ? '//tt.sankuai.com' : '//tt.cloud.test.sankuai.com';
    }
    get callBackUrl() {
        return '//tt.sankuai.com/ticket/create?cid=112&tid=2190&iid=9397';
    }
    get helpUrl() {
        return 'https://km.sankuai.com/page/134109797';
    }
    // 用户引导还没翻到最后一页
    get isCarouselNotOnLastPage() {
        const pageTotal = this.instruction.length || 0;
        return this.activeInstructionIndex + 1 < pageTotal;
    }
    // 设置sso登出地址
    get logoutUrl() {
        return '/sso/logout';
    }
    // 根据index获取当前用户引导内容
    get activeInstructionTitle() {
        if (!this.shouldShowInstruction) return '';
        return get(this, `instruction.${this.activeInstructionIndex}.title`, '');
    }
}
